/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .uweentity-form.hidden {
    display: none;
  }

  form.rjsf,
  div.rjsf {
    margin-top: -1.25rem;

    .alert {
      input {
        background-color: transparent;
        color: inherit;
        border-color: transparent;

        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }

    .form-group {
      .control-label {
        margin-bottom: 0.5rem;
      }

      .checkbox-inline > span,
      .checkbox > label > span,
      .field-radio-group > .radio,
      .radio-inline {
        margin-right: 8px;

        > input[type='checkbox'],
        > span > input[type='radio'] {
          margin-right: 8px;
        }
      }

      .field-radio-group.radio-group-buttons .btn + .btn {
        margin-left: 12px;
      }

      @media (min-width: 768px) {
        .input-wrapper,
        input,
        select,
        .dropdown {
          // max-width: 20rem;
        }
      }

      .btn.btn-block {
        margin-left: 3rem;
        margin-right: 3rem;
        width: 90%;
      }
    }

    .title-2-lines > label {
      height: 3em;
    }

    .array-field-vertical .array-item-list {
      flex-direction: column;
      max-width: 30rem;

      > .array-item {
        display: flex;

        td.array-item-field {
          .form-group:not(:has(.form-group)) {
            margin-top: 4px;
            margin-bottom: 4px;
          }
        }

        > .col-xs-9 {
          flex-grow: 1;

          .form-group {
            margin-bottom: 0;
          }
        }

        > .col-xs-3 {
          display: flex;
          align-items: center;
        }
      }
    }

    .array-cards > .array-item-list > .array-item.for-object-row {
      padding-left: 1em;
      padding-right: 1em;
    }

    tr.for-object-row > th {
      white-space: pre;
    }

    .array-item.for-object-row > td,
    tr.array-item.panel-row > td {
      padding: 0;

      > .form-group {
        margin-bottom: 0;

        > .control-label,
        .form-group > .control-label {
          display: none;
        }

        &.bordered > .form-group > .prop-fields,
        &.bordered > .form-group > .collapse > .prop-fields,
        &.bordered > .form-group > .collapsing > .prop-fields {
          padding-left: 12px;
          padding-right: 12px;
        }
      }
    }

    .array-item {
      td.array-item-field {
        .form-group {
          padding: 0 !important;
        }

        .form-group:not(:has(.form-group)) {
          margin-top: 4px;
          margin-bottom: 4px;
        }
      }

      td.array-item-toolbox {
        padding-left: 0;
        padding-right: 0;

        .btn-group .btn i.fa {
          transition: transform 100ms ease-in-out;
        }

        .btn-group .btn:hover {
          i.fa {
            transform: scale(1.1);
          }
        }
      }
    }

    .form-group:has(.form-group) {
      margin-bottom: 0;
    }

    .form-group.bordered {
      border: 1px solid ${$.gray100};
    }

    legend[id^='root_'][id$='__title'] {
      position: relative;
      cursor: default;
      border-radius: ${$.borderRadius} ${$.borderRadius} 0 0;
      box-sizing: content-box;

      @media (max-width: 768px) {
        margin-left: -5px;
        margin-right: 9px;
        padding-left: 14px;
        padding-right: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &.type-subsection,
      &.type-subsubsection {
        background-color: ${$.secondaryMain};
        color: inherit;
        width: auto;
        padding-left: 1.25rem;
        padding-right: 1.25rem;
        margin-left: 0rem;
        margin-right: 0rem;
        font-size: 1.25rem;
        font-weight: normal;

        &.bottom-section {
          border-radius: 0 0 12px 12px;
          margin-bottom: 12px;
        }

        &.type-subsubsection {
          font-size: 1rem;
        }

        > .expandable {
          top: -2px;
          right: 5px;
          color: inherit;

          > * {
            font-size: 1.75rem;
          }

          &.type-subsubsection > * {
            font-size: 1.5rem;
          }
        }
      }

      &.type-label {
        color: inherit;
        background-color: transparent;
      }

      > .expandable {
        position: absolute;
        right: 12px;
        height: 1.5em;
        width: 1.5em;
        background-color: transparent;
        border-width: 0;
        color: ${$.white};

        > * {
          font-size: 2.5rem;
        }
      }
    }

    legend.type-label:not(.control-label) {
      font-size: large;
    }

    .btn.btn-add {
      color: ${$.secondaryMain};
    }

    .radio-column > .field-radio-group {
      flex-direction: column;
    }

    legend#root__title:empty {
      margin: 0;
    }
  }

  .field-boolean {
    position: relative;

    > .checkbox {
      display: inline-block;
    }

    > .help-block {
      display: inline;
      margin-bottom: 0;
      vertical-align: middle;
    }
  }

  .help-block {
    display: inline;
    margin-bottom: 0;
    margin-left: 3px;
    vertical-align: middle;
  }

  .form-group.field.field-object.flex-row > fieldset {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > * {
      margin-left: 12px;
    }
  }

  .no-title > .animate-height > .auto-content > fieldset > legend,
  .no-title > fieldset > legend,
  .no-title > label {
    display: none;
  }

  .row-index {
    width: 4em;

    > .form-group > input {
      text-align: center;
    }
  }

  .form-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: -24px;
    margin-right: -24px;

    > .sidepanel {
      display: flex;
      flex-direction: column;
      --tab-width: 120px;
      --tab-height: 24px;
      --tab-gap: 10px;
      --tab-v-offset: calc(36px + 2 * 8px);
      --tab-border-radius: ${$.borderRadius};
      --collapsed-width: calc(var(--tab-height) + var(--tab-gap));
      --expanded-width: 260px;

      &.expanded {
        flex: 0 0 var(--expanded-width);
      }

      flex: 0 0 var(--collapsed-width);
      width: var(--collapsed-width);

      > .expandable-tab-side-panel-tab {
        width: var(--tab-width);
        height: var(--tab-height);
        border-radius: var(--tab-border-radius) var(--tab-border-radius) 0px 0px;
        font-size: 1rem;
        margin-bottom: var(--tab-width);
        border-width: 0;
        color: ${$.white};
        background-color: ${$.primaryMain};
      }

      > .expandable-tab-side-panel-panel {
        margin-left: calc(var(--tab-gap) / 2);
        margin-right: calc(var(--tab-gap) / 2);
        border-radius: ${$.borderRadius};

        > .card-header {
          position: relative;
          background-color: ${$.primaryMain};
          color: ${$.white};
          font-size: 1.65rem;
          padding-top: 0;
          font-weight: bold;
          padding-bottom: 0;

          > .btn-bar {
            position: absolute;
            right: 0;
            top: -8px;
            padding: 0;

            > .btn {
              position: relative;
              right: auto;
              top: auto;
              border-radius: 50%;
              border: 0;
              background-color: ${$.primaryMain};
              color: ${$.white};
              width: 24px;
              min-width: auto;
              max-width: auto;
              padding: 0;
              height: 24px;
              margin-left: 12px;

              &:hover {
                color: ${$.primaryMain};
                background-color: ${$.white};
              }
              .fa {
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        > .card-body {
          overflow: auto;
          max-height: 40vh;
          border-radius: 0;
        }

        &::after {
          content: ' ';
          height: 15px;
        }
      }

      > .expandable-tab-side-panel-tab + .expandable-tab-side-panel-panel {
        margin-top: var(--tab-v-offset);
      }

      > .expandable-tab-side-panel-panel + .expandable-tab-side-panel-panel {
        margin-top: calc(2 * var(--tab-gap));
      }

      &.sidepanel-left {
        > .expandable-tab-side-panel-tab {
          transform: rotate(-90deg) translate(calc(-1 * (var(--tab-width) + var(--tab-v-offset))), var(--tab-gap));
          transform-origin: top left;
        }

        &.expanded > .expandable-tab-side-panel-tab {
          transform: rotate(-90deg) translate(calc(-1 * (var(--tab-width) + var(--tab-v-offset))), calc(var(--expanded-width) - var(--tab-height)));
        }

        order: 1;
      }

      &.sidepanel-right {
        > .expandable-tab-side-panel-tab {
          transform: rotate(90deg) translate(calc(var(--tab-width) + var(--tab-v-offset)), calc(var(--tab-width) - var(--tab-height)));
          transform-origin: top right;
        }

        &.expanded > .expandable-tab-side-panel-tab {
          transform: rotate(90deg) translate(calc(var(--tab-width) + var(--tab-v-offset) - var(--tab-height)), var(--tab-width));
          transform-origin: bottom right;
        }

        order: 3;
      }
    }

    > .form-component {
      order: 2;
      width: 100%;
    }

    > .toolbar-bottom-affix {
      position: fixed;
      bottom: 0;
      margin-left: 5px;
    }
  }

  .form-group.field.field-inline {
    display: flex;
    flex-direction: row;

    > label {
      margin-bottom: 0;
      padding-right: 12px;

      &:after {
        content: ': ';
      }
    }

    > .form-group {
      margin-bottom: 0;
      flex-grow: 1;

      > input {
        width: 100%;
        max-width: 1200px;
      }
    }
  }

  .has-buttons-position-top {
    position: relative;

    .buttons-position-top {
      top: 3px;
      position: absolute;
      right: 40px;
    }
  }

  .has-buttons-position-top-outside {
    position: relative;
    display: flex;
    margin-left: 5em;
    justify-content: space-between;

    .buttons-position-top {
      flex-grow: 0;
      flex-shrink: 0;
    }
  }

  $cell-widths: (
    l: 16rem,
    m: 10rem,
    sm: 4.5rem,
  );

  th,
  td {
    &.w-l {
      width: 16rem;
      max-width: 16rem;
    }
    &.w-m {
      width: 10rem;
      max-width: 10rem;
    }
    &.w-sm {
      width: 4.5rem;
      max-width: 4.5rem;
    }
  }

  .for-object-row {
    > th {
      text-align: center;
      vertical-align: middle;
    }

    .w-sm-s {
      width: 4.5rem;
      font-size: 13px;
      padding: 2px;
    }

    ::-webkit-input-placeholder,
    .w-sm-s :-ms-input-placeholder,
    .w-sm-s ::placeholder {
      color: #b4b4b4;
      font-size: 14px;
    }
  }

  .div-login {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 3.5rem;
  }

  .div-login > .form-component {
    width: 45%;
  }

  .quill {
    height: 300px;
  }

  .schema-field {
    .row {
      margin-bottom: 8px;
    }

    .schema-field-delete-btn {
      margin-bottom: -4px;
      padding: 0;
    }
  }

  .property-table {
    width: 100%;

    td .array-item-remove {
      .fa-times {
        transition: transform 100ms ease-in-out;
      }

      &:hover {
        .fa-times {
          transform: scale(1.1);
        }
      }
    }
  }

  .autocomplete {
    .autocomplete__control {
      border-color: ${$.inputBorderColor};
      border-radius: ${$.inputBorderRadiusLg};

      &:hover {
        border-color: ${$.inputBorderColor};
      }

      &.autocomplete__control--is-focused {
        outline: 0;
        box-shadow: none;
        border-color: ${$.primaryMain};
      }
    }
  }

  .align-end {
    align-items: flex-end;
  }

  .text-input-tooltip {
    color: white;
    background-color: black;
  }

  .select-auto-width {
    display: inline-block;
    width: 100%;
  }

  .select-auto-width select {
    min-width: 250px !important;
  }

  .min-width-250 {
    min-width: 250px;
  }

  .min-width-300 {
    min-width: 300px;
  }

  .min-width-400 {
    min-width: 400px;
  }

`;
